import { _ as __makeTemplateObject, d as __assign, u as useCogniteContext, f as __read, b as __awaiter, e as __generator } from '../../chunks/chunk-525a49bc.js';
import { Icon, Dropdown, Menu, Card } from 'antd';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { w as withDefaultTheme } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import moment from 'moment';

var defaultStrings = {
    noData: 'No Data',
};
var generateDropdownMenu = function (_a) {
    var options = _a.options, onClick = _a.onClick, timeseries = _a.timeseries, _b = _a.styles, styles = _b === void 0 ? {} : _b;
    var _c = styles.menu, menu = _c === void 0 ? {} : _c, _d = styles.item, item = _d === void 0 ? {} : _d;
    var items = Object.keys(options).map(function (key) { return (React.createElement(Menu.Item, { key: key, onClick: function () { return onClick(key, timeseries); }, style: item },
        React.createElement("span", null, options[key]))); });
    return React.createElement(Menu, { style: __assign({ padding: 0, borderRadius: 0 }, menu) }, items);
};
var TimeseriesPreview = function (_a) {
    var timeseriesId = _a.timeseriesId, dropdown = _a.dropdown, onToggleVisibility = _a.onToggleVisibility, _b = _a.color, color = _b === void 0 ? '#6c65ee' : _b, valueToDisplay = _a.valueToDisplay, nameFormatter = _a.nameFormatter, descriptionFormatter = _a.descriptionFormatter, retrieveTimeseries = _a.retrieveTimeseries, retrieveLatestDatapoint = _a.retrieveLatestDatapoint, _c = _a.updateInterval, updateInterval = _c === void 0 ? 5000 : _c, _d = _a.dateFormat, dateFormat = _d === void 0 ? 'DD MMM YYYY - HH:mm:ss' : _d, formatDisplayValue = _a.formatDisplayValue, _e = _a.styles, styles = _e === void 0 ? {} : _e, _f = _a.strings, strings = _f === void 0 ? {} : _f;
    var _g = styles.wrapper, wrapperStyle = _g === void 0 ? {} : _g, _h = styles.card, cardStyle = _h === void 0 ? {} : _h, _j = styles.leftSide, leftSideStyle = _j === void 0 ? {} : _j, _k = styles.rightSide, rightSideStyle = _k === void 0 ? {} : _k, _l = styles.tagName, tagNameStyle = _l === void 0 ? {} : _l, _m = styles.description, descriptionStyle = _m === void 0 ? {} : _m, _o = styles.value, valueStyle = _o === void 0 ? {} : _o, _p = styles.date, dateStyle = _p === void 0 ? {} : _p, _q = styles.dropdown, dropdownStyle = _q === void 0 ? {} : _q;
    var lang = __assign(__assign({}, defaultStrings), strings);
    var context = useCogniteContext(Component, true);
    var _r = __read(useState(true), 2), loading = _r[0], setLoading = _r[1];
    var _s = __read(useState(), 2), timeseries = _s[0], setTimeseries = _s[1];
    var _t = __read(useState(), 2), intervalPointer = _t[0], setIntervalPointer = _t[1];
    var _u = __read(useState(), 2), latestDatapoint = _u[0], setLatestDatapoint = _u[1];
    var onVisibilityClick = function () {
        if (onToggleVisibility && timeseries) {
            onToggleVisibility(timeseries);
        }
    };
    var dropdownMenu = dropdown && timeseries ? (React.createElement(Dropdown, { overlay: generateDropdownMenu(__assign(__assign({}, dropdown), { timeseries: timeseries, styles: dropdownStyle })), trigger: ['click'] },
        React.createElement(ActionIcon, { type: "ellipsis" }))) : null;
    var displayValue = function () {
        var value = valueToDisplay
            ? valueToDisplay.value
            : latestDatapoint
                ? latestDatapoint.value
                : undefined;
        return formatDisplayValue ? formatDisplayValue(value) : value;
    };
    var displayDate = function () {
        var date = valueToDisplay
            ? valueToDisplay.timestamp
            : latestDatapoint
                ? latestDatapoint.timestamp
                : undefined;
        return date ? moment(date).format(dateFormat) : undefined;
    };
    useEffect(function () {
        var canceled = false;
        var fetchTimeseries = function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var timeseriesById, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        if (!retrieveTimeseries) return [3 /*break*/, 2];
                        return [4 /*yield*/, retrieveTimeseries({ id: id })];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, context.timeseries.retrieve([{ id: id }])];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        timeseriesById = _a;
                        if (timeseriesById.length && !canceled) {
                            setTimeseries(timeseriesById[0]);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        console.error(e_1);
                        return [3 /*break*/, 6];
                    case 6:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchTimeseries(timeseriesId);
        return function () {
            canceled = true;
        };
    }, [timeseriesId]);
    useEffect(function () {
        var canceled = false;
        var fetchLatestDatapoint = function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var latest, _a, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        if (!retrieveLatestDatapoint) return [3 /*break*/, 2];
                        return [4 /*yield*/, retrieveLatestDatapoint({ id: id })];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, context.datapoints.retrieveLatest([{ id: id }])];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        latest = _a;
                        if (latest.length && latest[0].datapoints[0] && !canceled) {
                            setLatestDatapoint(latest[0].datapoints[0]);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _b.sent();
                        console.error(e_2);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        clearInterval(intervalPointer);
        if (valueToDisplay === undefined) {
            var pointer = setInterval(function () {
                if (canceled) {
                    clearInterval(intervalPointer);
                    return;
                }
                fetchLatestDatapoint(timeseriesId);
            }, updateInterval);
            fetchLatestDatapoint(timeseriesId);
            setIntervalPointer(pointer);
        }
        return function () {
            canceled = true;
        };
    }, [valueToDisplay, timeseriesId]);
    return (React.createElement(Wrapper, { style: wrapperStyle },
        React.createElement(Card, { bordered: false, bodyStyle: __assign({ padding: 0 }, cardStyle), loading: loading }, timeseries && (React.createElement(CardBody, null,
            React.createElement(LeftSide, { style: __assign({ backgroundColor: color }, leftSideStyle) },
                onToggleVisibility && (React.createElement(ActionIcon, { "data-test-id": 'visibility', type: "eye", onClick: onVisibilityClick })),
                dropdownMenu),
            React.createElement(RightSide, { style: rightSideStyle },
                React.createElement(TagName, { style: tagNameStyle, "data-test-id": 'name' }, nameFormatter
                    ? nameFormatter(timeseries.name)
                    : timeseries.name),
                React.createElement("p", { style: descriptionStyle, "data-test-id": 'description' }, descriptionFormatter
                    ? descriptionFormatter(timeseries.description)
                    : timeseries.description),
                React.createElement(ValueContainer, { "data-test-id": 'value' },
                    React.createElement(Value, { style: valueStyle },
                        React.createElement("span", null, displayValue() || lang.noData)),
                    React.createElement(DateValue, { style: dateStyle },
                        React.createElement("span", null, displayDate())))))))));
};
var Component = withDefaultTheme(TimeseriesPreview);
Component.displayName = 'TimeseriesPreview';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 300px;\n  display: inline-block;\n\n  .ant-card-loading-content {\n    padding: 0 !important;\n  }\n"], ["\n  min-width: 300px;\n  display: inline-block;\n\n  .ant-card-loading-content {\n    padding: 0 !important;\n  }\n"])));
var CardBody = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var LeftSide = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 40px;\n  min-width: 40px;\n  padding: 10px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: #fff;\n  font-size: 18px;\n"], ["\n  width: 40px;\n  min-width: 40px;\n  padding: 10px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: #fff;\n  font-size: 18px;\n"])));
var RightSide = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 10px;\n  background-color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 10px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gearbox.lightGrey;
});
var ActionIcon = styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var TagName = styled.p(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 0.8em;\n  font-weight: 600;\n"], ["\n  font-size: 0.8em;\n  font-weight: 600;\n"])));
var ValueContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: baseline;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: baseline;\n"])));
var Value = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-weight: 600;\n  padding-right: 10px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  font-weight: 600;\n  padding-right: 10px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])));
var DateValue = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: 0.8em;\n  text-align: right;\n"], ["\n  font-size: 0.8em;\n  text-align: right;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

export { Component as TimeseriesPreview };
